import { AccountView } from './mapAccount';
import { AccountsTab } from './deriveRows';

/**
 * Excel on Windows reads a BOM-less file as legacy 8-bit, which mangles the non-ASCII
 * manager names on this list (e.g. "Yvonne Pañgan"). The BOM marks it as UTF-8.
 */
export const CSV_BOM = '﻿';

// RFC 4180: quote a field only when it contains a delimiter, a quote, or a line break,
// and escape an embedded quote by doubling it. Company names on this list really do
// contain commas ("Ablaza, Xavier Luis Jacomina"), so this is load-bearing, not defensive.
const cell = (value: string): string =>
  /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;

const nameHeader = (tab: AccountsTab): string =>
  tab === 'companies' ? 'Company Name' : 'Project Name';

/**
 * Serialize accounts to CSV text. The caller passes the rows it is already showing, so
 * the export inherits the active tab, the search term, the show-inactive toggle and the
 * sort order for free — "export the filtered results" needs no filter logic of its own.
 */
export const accountsCsvText = (
  rows: AccountView[],
  tab: AccountsTab
): string => {
  const lines = [
    [nameHeader(tab), 'Manager', 'Inbox Email', 'Status'].join(','),
    ...rows.map((r) =>
      [r.name, r.managerName, r.email, r.active ? 'Active' : 'Inactive']
        .map(cell)
        .join(',')
    ),
  ];

  return CSV_BOM + lines.join('\r\n');
};

const pad = (n: number): string => String(n).padStart(2, '0');

/** e.g. `companies-2026-08-20.csv`. Date-first-sortable, so a folder of exports reads chronologically. */
export const accountsCsvFilename = (tab: AccountsTab, now: Date): string => {
  const label = tab === 'companies' ? 'companies' : 'internal-projects';
  return `${label}-${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}.csv`;
};
